import { ArrowDown, PlayCircle } from "lucide-react";
import React from "react";
import Workplace from "../components/app/careers/Workplace";
import Benefits from "../components/app/careers/Benefits";
import EarlyAccess from "../components/app/common/EarlyAccess";
import Social, { ISocials } from "../components/app/common/Socials";
import Team from "../components/app/common/Team";
import CareerTimeline from "../components/app/careers/CareerTimeline";
// import Stories from "../components/app/careers/Stories";
import Positions from "../components/app/careers/Positions";
import { BlurFade } from "../components/app/BlurFade";
import CareerTestimonials from "../components/app/careers/CareerTestimonial";
import { useState } from "react";
import CareerVideoModal from "../components/app/careers/CareerVideoModal";

const CareersPage: React.FC = () => {
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);

  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];

  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dream_weaversg/",
    },
  ];
  const teamImagesArray: string[] = [
    "/careers/team/team-image-1.png",
    "/careers/team/team-image-2.png",
    "/careers/team/team-image-3.png",
    "/careers/team/team-image-4.png",
    "/careers/team/team-image-5.png",
    "/careers/team/team-image-6.png",
  ];

  const toggleShowVideoModal = () => {
    setShowVideoModal((prev) => !prev);
  };

  return (
    <div>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 xl:p-24 w-full flex flex-col justify-center items-center min-h-[70vh]">
          <div className="w-full grid md:grid-cols-2 gap-16">
            <div className="space-y-3 flex flex-col ">
              <h2 className="text-4xl xl:text-5xl lg:pb-5">Join the team</h2>
              <div className="text-xs md:text-sm lg:text-base xl:text-lg">
                <p>
                  Dream Weavers is an employee-centred company that looks after
                  every employee, gives autonomy to make choices, supports
                  self-development and career growth. Our development team is
                  always in search of talented individuals to join our
                  employee-centred culture.
                </p>
                <p className="pt-5 md:pt-6 lg:pt-8">
                  Navigate below to see our current open positions!
                </p>
              </div>
              <div className="pt-5 md:pt-6 lg:pt-8 xl:pt-16">
                <a href="#positions">
                  <button className="text-sm text-white px-4 rounded-full py-1.5 flex justify-center items-center bg-[#0040D8] lg:text-base xl:text-2xl lg:py-3">
                    Open positions <ArrowDown className="w-4 ml-1" />
                  </button>
                </a>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <div
                className="flex rounded-full cursor-pointer relative group"
                onClick={toggleShowVideoModal}
              >
                <img
                  src="/careers/hero-placeholder1.png"
                  alt=""
                  className="h-auto max-h-72 md:max-h-96 rounded-full"
                />
                <div className="absolute inset-0 flex justify-center bg-black/10 rounded-full items-center">
                  <PlayCircle className="text-white w-16 md:w-20 lg:h-10 opacity-100 transform group-hover:scale-105 transition-all duration-300 ease-in-out" />
                </div>
              </div>
              <div className="-ml-5">
                <img
                  src="/careers/career-hero.png"
                  alt=""
                  className="h-auto max-h-72 md:max-h-96 animate-float"
                />
              </div>
            </div>
          </div>
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 xl:px-20">
          <Workplace />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 xl:p-16 lg:pt-0 xl:pt-0">
          <Benefits />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="bg-[#34368A] p-5 sm:p-7 lg:p-16 xl:px-28">
          <Team
            text="Check our Team of Professionals"
            imagesArray={teamImagesArray}
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 ">
          <CareerTestimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback from your teammates."
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section>
          <CareerTimeline />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="bg-[#F7F9FC]" id="positions">
          {/* <Positions /> */}
          <div>
            <div className="lg:flex flex-col gap-5 p-5 sm:p-7 lg:p-10 xl:p-16 xl:pb-6 hidden justify-center items-center w-full">
              <h3 className="text-xl text-center xl:text-[3.2rem] lg:pt-10 font-medium sm:text-2xl md:text-3xl lg:text-4xl">
                We have open positions now !
              </h3>
              <h5>The deadline for submission has been officially extended to February 26, 2026. </h5>
              <h5>Apply Link: <a className="text-[#0825D7] underline" href="https://dreamweaversgroup.co.in/careers/application.php">https://dreamweaversgroup.co.in/careers/application.php</a></h5>
            </div>
            <div className="flex flex-col gap-5 p-5 sm:p-7 lg:p-10 xl:p-16 lg:hidden bg-[#0040D8] items-center">
              <h3 className="text-xl text-center w-full text-white font-medium sm:text-2xl md:text-3xl lg:text-4xl">
                We have open positions now !
              </h3>
              <h5 className="text-white">The deadline for submission has been officially extended to February 26, 2026. </h5>
              <h5 className="text-white break-all">Apply Link: <a className="text-white underline" href="https://dreamweaversgroup.co.in/careers/application.php">https://dreamweaversgroup.co.in/careers/application.php</a></h5>
            </div>
            <img src="/careers/Ad_Dream_Weavers_NSQF_J_K_2026.jpeg" alt="Positions" className="sm:w-[100%] lg:w-[70%] lg:pb-6 lg:m-auto" />
          </div>
        </section>
      </BlurFade>
      {/* <BlurFade delay={0.25} inView>
        <section className="bg-[#182152] p-5 sm:p-7 lg:p-16 xl:px-28">
          <Stories />
        </section>
      </BlurFade> */}
      <section className="md:px-10">
        <Social socialLinks={socialLinks} images={socialImages} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
      <CareerVideoModal
        isOpen={showVideoModal}
        onClose={toggleShowVideoModal}
      />
    </div>
  );
};

export default CareersPage;
